import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './auth-interceptor.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './views/header/header.component';
import { LoginComponent } from './views/login/login.component';
import { ActivateAccountComponent } from './views/activate-account/activate-account.component';
import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { OverviewComponent } from './views/overview/overview.component';
import { ClaimPopupComponent } from './components/claim-popup/claim-popup.component';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { GlobalService } from './services/global.service';
import { MailTokenGuard } from './guards/mail-token.guard';
import { AuthGuard } from './guards/auth.guard';
import { BreederService } from './services/breeder.service';
import { EmailService } from './services/email.service';
import { ToastrModule } from 'ngx-toastr';
import { ErrorInterceptorService } from './error-interceptor.service';
import { TermsOfUseComponent } from './views/terms-of-use/terms-of-use.component';
import { RegisterBreederComponent } from './views/register-breeder/register-breeder.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    ActivateAccountComponent,
    ForgotPasswordComponent,
    OverviewComponent,
    ClaimPopupComponent,
    TermsOfUseComponent,
    RegisterBreederComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true
    },
    GlobalService,
    AuthService,
    UserService,
    BreederService,
    EmailService,
    AuthGuard,
    MailTokenGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
